import { useTranslation } from 'react-i18next';
import { Button } from '@octano/global-ui';

import SectionTitle from '../../../../../../components/text/SectionTitle';
import { TranslationsKeys } from '../../../../../../locales/translations';
import { HomologationSemester } from '../../../types';
import CourseCard from './CourseCard';

interface Props {
  semesters: HomologationSemester[];
  onDownloadDocumentation?: () => void;
}

const LEGEND_ITEMS = [
  { color: 'rgba(25, 118, 210, 0.08)', border: '#1976d2', key: 'selected' },
  { color: 'rgba(76, 175, 80, 0.08)', border: '#4caf50', key: 'approved' },
  { color: 'rgba(244, 67, 54, 0.08)', border: '#f44336', key: 'rejected' },
] as const;

export default function CurriculumGrid({
  semesters,
  onDownloadDocumentation,
}: Props) {
  const { t } = useTranslation(TranslationsKeys.HOMOLOGATION_DETAIL);

  return (
    <div className="mt-3 mb-4">
      <div className="d-flex justify-content-between align-items-start">
        <div>
          <SectionTitle text={t('curriculumTitle')} />
          <p className="fs-14 fw-300 mt-1 mb-0">{t('curriculumDescription')}</p>
        </div>
        {onDownloadDocumentation && (
          <Button
            text={t('downloadDocumentation')}
            icon="download"
            outlined
            size="sm"
            onClick={onDownloadDocumentation}
          />
        )}
      </div>

      {/* Horizontal scrollable grid - reuses _curriculum.scss */}
      <div className="semesters-list mt-2 mb-3 ">
        {semesters.map((semester) => (
          <div
            key={semester.id}
            className="semester"
            style={{ width: '140px', marginRight: '10px' }}
          >
            <div className="semester-courses">
              <span
                className="title"
                style={{ width: '100%', textAlign: 'center' }}
              >
                {semester.name}
              </span>
              {semester.semesterCourses.map((sc) => (
                <CourseCard key={sc.id} semesterCourse={sc} />
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Legend */}
      <div className="d-flex align-items-center pt-3" style={{ gap: 12 }}>
        {LEGEND_ITEMS.map((item) => (
          <div key={item.key} className="d-flex align-items-center">
            <div
              style={{
                width: 25,
                height: 25,
                background: item.color,
                border: `1px solid ${item.border}`,
                borderRadius: 4,
              }}
            />
            <p className="fs-14 fw-600 pl-2 m-0">{t(`legend.${item.key}`)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
